import Vue from 'vue'
import text_cs from './cs.js'
import text_en from './en.js'


export default {

  data : {"cs":text_cs, "en": text_en},
  available: ['cs', 'en'],
  lang : 'cs',

  get(key, fill) {
    let result = key
    if (this.data[this.lang] != null && this.data[this.lang].text[key] != undefined) {
      result = this.data[this.lang].text[key]
    }
    if (fill) {
      for(let i = 0; i < fill.length; i++) {
        result = result.replace('%' + i, fill[i])
      }
    }
    return result
  },

  setLang(lang) {
    if (this.available.indexOf(lang) == -1) {
      return false
    }

    this.lang = lang
    return true
  }

}
